import type { OddsEntry } from '../types';

/**
 * Whether prize-breakdown data is ready to render.
 *
 * Staging can return a drawing with numbers before odds publish: `odds` may be absent, an empty
 * list, entries that still have no `ranks`, or rank groups whose condition list is still empty.
 * Those shapes must not mount PrizeTables. A sibling entry with no `ranks` is safe, because the
 * mappers skip a missing ranks object. An empty condition list is not: every mapper reads
 * `conditions[0]`.
 */
function hasUsablePrizeOdds(odds: OddsEntry[] | null | undefined): odds is OddsEntry[] {
  if (!odds?.length) {
    return false;
  }

  const rankGroups = odds.flatMap(entry => Object.values(entry.ranks ?? {}));

  return rankGroups.length > 0 && rankGroups.every(conditions => Array.isArray(conditions) && conditions.length > 0);
}

export { hasUsablePrizeOdds };
